const doc = [({"installment":"Installment payment", "limited_subscription":"Limited subscription", "one_time":"One-time", "subscription":"Subscription "})];
module.exports = doc.length <= 1 ? doc[0] : doc;